<div class="py-6 pb-12 font-sans text-slate-800">
  <section *ngIf="chargementEnCours"
    class="flex min-h-[500px] w-full flex-col items-center justify-center gap-3 rounded-xl border border-slate-200 bg-white px-4">
    <svg class="h-8 w-8 shrink-0 animate-spin text-blue-600" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
      <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"></path>
    </svg>
    <p class="text-center text-[13px] text-slate-500">
      Chargement des statistiques de connexion…
    </p>
  </section>
  <section *ngIf="!chargementEnCours && erreurChargement"
    class="flex flex-col items-center justify-center gap-3 rounded-xl border border-red-200 bg-red-50 p-16 text-center">
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" class="text-red-500" aria-hidden="true">
      <circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.6" />
      <path d="M12 8v5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
      <circle cx="12" cy="16.5" r="1.1" fill="currentColor" />
    </svg>
    <p class="text-[14px] font-semibold text-red-700">Impossible de charger les statistiques de connexion.</p>
    <p class="text-[13px] text-red-500">Veuillez réessayer ou vérifier votre connexion.</p>
    <button type="button"
      class="mt-1 flex items-center gap-2 rounded-md bg-red-600 px-4 py-2 text-[13px] font-semibold text-white hover:bg-red-700"
      (click)="chargerStats()">
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path d="M4 4v5h5M20 20v-5h-5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"
          stroke-linejoin="round" />
        <path d="M5.5 15A8 8 0 0 0 20 12M18.5 9A8 8 0 0 0 4 12" stroke="currentColor" stroke-width="1.8"
          stroke-linecap="round" />
      </svg>
      Réessayer
    </button>
  </section>

  <ng-container *ngIf="!chargementEnCours && !erreurChargement">
    <section class="mb-6 grid grid-cols-2 gap-4 md:grid-cols-4 p-4">
      <article *ngFor="let carte of cartesResume"
        class="flex items-start gap-3.5 rounded-xl border border-slate-200 p-4" [ngClass]="{
            'bg-blue-50': carte.icone === 'effectif',
            'bg-indigo-50': carte.icone === 'effectif-fode',
            'bg-emerald-50': carte.icone === 'connectes',
            'bg-red-50': carte.icone === 'jamais-connectes'
          }">
        <span class="flex h-[38px] w-[38px] flex-none items-center justify-center rounded-[10px]" [ngClass]="{
            'bg-blue-100 text-blue-600': carte.icone === 'effectif',
            'bg-indigo-100 text-indigo-600': carte.icone === 'effectif-fode',
            'bg-emerald-100 text-emerald-600': carte.icone === 'connectes',
            'bg-red-100 text-red-600': carte.icone === 'jamais-connectes'
          }">
          <ng-container [ngSwitch]="carte.icone">
            <svg *ngSwitchCase="'effectif'" width="20" height="20" viewBox="0 0 24 24" fill="none">
              <circle cx="9" cy="8" r="3" stroke="currentColor" stroke-width="1.6" />
              <path d="M3 20c0-3.3 2.7-6 6-6s6 2.7 6 6" stroke="currentColor" stroke-width="1.6"
                stroke-linecap="round" />
              <circle cx="17" cy="9" r="2.4" stroke="currentColor" stroke-width="1.6" />
              <path d="M15 20c.2-2.6 2-4.6 4.5-5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" />
            </svg>
            <svg *ngSwitchCase="'effectif-fode'" width="20" height="20" viewBox="0 0 24 24" fill="none">
              <rect x="3" y="4" width="18" height="14" rx="2" stroke="currentColor" stroke-width="1.6" />
              <path d="M3 9h18" stroke="currentColor" stroke-width="1.6" />
              <circle cx="7.5" cy="13.5" r="1.4" fill="currentColor" />
              <path d="M11.5 13.5h6" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" />
              <path d="M7 21h10" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" />
            </svg>
            <svg *ngSwitchCase="'connectes'" width="20" height="20" viewBox="0 0 24 24" fill="none">
              <path d="M5 12.5a10 10 0 0 1 14 0" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" />
              <path d="M8 15.5a6 6 0 0 1 8 0" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" />
              <circle cx="12" cy="19" r="1.4" fill="currentColor" />
            </svg>
            <svg *ngSwitchCase="'jamais-connectes'" width="20" height="20" viewBox="0 0 24 24" fill="none">
              <circle cx="12" cy="12" r="8.5" stroke="currentColor" stroke-width="1.6" />
              <path d="M9 9l6 6M15 9l-6 6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
            </svg>
          </ng-container>
        </span>
        <div>
          <span class="mb-1.5 block text-[13px] font-medium text-slate-600">{{ carte.label }}</span>
          <strong class="block text-2xl font-bold leading-tight text-slate-800">{{ carte.valeur | number }}</strong>
          <span class="mt-1 block text-[12.5px] text-slate-400">{{ carte.sousTexte }}</span>
        </div>
      </article>
    </section>
    <section
      class="mb-6 flex flex-wrap items-center justify-between gap-3 rounded-xl border border-slate-200 bg-white p-4">
      <div class="flex items-center gap-4 text-[12.5px] text-slate-600">
        <span class="font-semibold text-slate-800">Légende :</span>
        <span class="flex items-center gap-1"><strong
            class="rounded bg-slate-100 px-1.5 py-0.5 text-slate-800">M</strong> : Masculin</span>
        <span class="flex items-center gap-1"><strong
            class="rounded bg-slate-100 px-1.5 py-0.5 text-slate-800">F</strong> : Féminin</span>
        <span class="flex items-center gap-1"><strong
            class="rounded bg-slate-100 px-1.5 py-0.5 text-slate-800">N/R</strong> : Non renseigné</span>
      </div>

      <div class="flex flex-wrap items-center gap-3">
        <button type="button" matTooltip="Exporter l'ensemble des données au format Excel" matTooltipPosition="above"
          class="flex h-10 items-center gap-2 rounded-md bg-blue-900 px-4 text-[13px] font-semibold text-white transition hover:bg-blue-800"
          (click)="exporterToutXls()">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path d="M12 3v12m0 0l-4-4m4 4l4-4" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"
              stroke-linejoin="round" />

            <path d="M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2" stroke="currentColor" stroke-width="1.8"
              stroke-linecap="round" />
          </svg>
        </button>
        <div class="relative h-10">
          <select
            class="h-10 w-auto min-w-[190px] max-w-[230px] appearance-none rounded-md border border-blue-200 bg-blue-50 py-0 pl-3 pr-8 text-[13px] text-slate-700 focus:border-blue-400 focus:outline-none"
            [(ngModel)]="certificatIdSelectionne" (ngModelChange)="onSelectionCertificat($event)">
            <option value="" disabled selected>
              -- Choisir un certificat --
            </option>

            <option *ngFor="let c of certificats" [value]="c.id">
              {{ c.nom }}
            </option>
          </select>

          <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
            class="pointer-events-none absolute right-2.5 top-1/2 -translate-y-1/2 text-blue-400">
            <path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
        </div>
        <button type="button" *ngIf="totaux.jamaisConnectes.total > 0"
          class="flex h-10 items-center gap-2 rounded-md bg-amber-600 px-4 text-[13px] font-semibold text-white transition hover:bg-amber-700 disabled:cursor-not-allowed disabled:opacity-60"
          (click)="demanderConfirmationNotification()" [disabled]="envoiNotificationEnCours">
          <svg *ngIf="envoiNotificationEnCours" width="14" height="14" class="animate-spin" viewBox="0 0 24 24"
            fill="none" aria-hidden="true">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>

            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"></path>
          </svg>

          <svg *ngIf="!envoiNotificationEnCours" width="14" height="14" viewBox="0 0 24 24" fill="none"
            aria-hidden="true">
            <path d="M4 6l8 6 8-6M4 6h16v12H4V6z" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>

          {{
          envoiNotificationEnCours
          ? 'Envoi en cours…'
          : 'Notifier les apprenants jamais connectés'
          }}
        </button>
        <div *ngIf="popupConfirmationNotification"
          class="fixed inset-0 z-50 flex items-center justify-center bg-black/40 px-4"
          (click)="annulerConfirmationNotification()">
          <div class="w-full max-w-sm rounded-xl bg-white p-6 shadow-xl" (click)="$event.stopPropagation()">
            <div class="mb-3 flex items-center gap-3">
              <span
                class="flex h-10 w-2 flex-none items-center justify-center rounded-full bg-amber-100 text-amber-600">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.6" />
                  <path d="M12 8v5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
                  <circle cx="12" cy="16.5" r="1.1" fill="currentColor" />
                </svg>
              </span>
              <h3 class="text-[15px] font-bold text-slate-800">
                Confirmer l'envoi
              </h3>
            </div>
            <p class="mb-5 text-[13.5px] text-slate-600">
              Voulez-vous vraiment notifier tous les apprenants jamais connectés ? Un email sera envoyé à chacun
              d'entre eux.
            </p>
            <div class="flex items-center gap-3">
              <button type="button"
                class="flex-1 rounded-md border bg-red-600  px-4 py-2 text-[13px] font-semibold text-white"
                (click)="annulerConfirmationNotification()">
                Annuler
              </button>
              <button type="button" class="flex-1 rounded-md bg-blue-600 px-4 py-2 text-[13px] font-semibold text-white"
                (click)="confirmerEnvoiNotification()">
                Confirmer
              </button>
            </div>
          </div>
        </div>
        <div *ngIf="popupNotification.visible"
          class="fixed inset-0 z-50 flex items-center justify-center bg-black/40 px-4"
          (click)="fermerPopupNotification()">
          <div class="w-full max-w-sm rounded-xl bg-white p-6 shadow-xl" (click)="$event.stopPropagation()">
            <div class="mb-3 flex items-center gap-3">
              <span class="flex h-10 w-2 flex-none items-center justify-center rounded-full"
                [ngClass]="popupNotification.succes ? 'bg-emerald-100 text-emerald-600' : 'bg-red-100 text-red-600'">
                <svg *ngIf="popupNotification.succes" width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path d="M5 13l4 4L19 7" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                    stroke-linejoin="round" />
                </svg>
                <svg *ngIf="!popupNotification.succes" width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.6" />
                  <path d="M12 8v5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
                  <circle cx="12" cy="16.5" r="1.1" fill="currentColor" />
                </svg>
              </span>
              <h3 class="text-[15px] font-bold text-slate-800">
                {{ popupNotification.succes ? 'Notifications envoyées' : 'Échec de l\'envoi' }}
              </h3>
            </div>
            <p class="mb-5 text-[13.5px] text-slate-600">{{ popupNotification.message }}</p>
            <button type="button"
              class="w-full rounded-md bg-slate-800 px-4 py-2 text-[13px] font-semibold text-white hover:bg-slate-900"
              (click)="fermerPopupNotification()">
              Fermer
            </button>
          </div>
        </div>
        <app-certificat-detail-modal [visible]="detailVisible" [chargementEnCours]="chargementDetailEnCours"
          [erreur]="erreurDetailCertificat" [certificat]="certificatSelectionne" (fermer)="fermerDetailCertificat()">
        </app-certificat-detail-modal>
      </div>
    </section>
    <section class="mb-6 rounded-xl border border-slate-200 bg-white p-5 pb-4">
      <div class="mb-4 flex items-center justify-between">
        <h2 class="text-[15px] font-bold text-blue-600">Détail des connexions par certificat</h2>
        <div class="flex items-center gap-3">
          <button type="button"
            class="flex items-center gap-1.5 rounded-md border border-blue-600 px-3.5 py-1.5 text-[13px] font-semibold text-blue-600 hover:bg-blue-50"
            (click)="exporterXls('absolues')">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <path d="M12 3v12m0 0l-4-4m4 4l4-4" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"
                stroke-linejoin="round" />
              <path d="M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2" stroke="currentColor" stroke-width="1.8"
                stroke-linecap="round" />
            </svg>
            Exporter cette vue en XLS
          </button>
        </div>
      </div>

      <div class="overflow-x-auto pb-3">
        <table class="w-full min-w-[1080px] border-collapse text-[13px]">
          <thead>
            <tr>
              <th rowspan="2"
                class="sticky left-0 z-10 w-[28%] border border-slate-200 bg-slate-100 px-3 py-2.5 text-left align-middle font-bold text-slate-800">
                Certificat
              </th>
              <th colspan="4"
                class="w-[24%] border border-blue-200 bg-blue-100 px-3 py-2 text-center text-[13px] font-bold text-blue-900">
                Enrôlés Moodle
              </th>
              <th colspan="4"
                class="w-[24%] border border-emerald-200 bg-emerald-100 px-3 py-2 text-center text-[13px] font-bold text-emerald-900">
                Connectés
              </th>
              <th colspan="4"
                class="w-[24%] border border-red-200 bg-red-100 px-3 py-2 text-center text-[13px] font-bold text-red-900">
                Jamais connectés
              </th>
            </tr>
            <tr>
              <th class="w-[6%] border border-blue-200 bg-blue-50 px-2 py-1.5 text-center font-semibold text-blue-700">M
              </th>
              <th class="w-[6%] border border-blue-200 bg-blue-50 px-2 py-1.5 text-center font-semibold text-blue-700">F
              </th>
              <th class="w-[6%] border border-blue-200 bg-blue-50 px-2 py-1.5 text-center font-semibold text-blue-700">
                N/R</th>
              <th class="w-[6%] border border-blue-200 bg-blue-100 px-2 py-1.5 text-center font-bold text-blue-900">
                Total</th>
              <th
                class="w-[6%] border border-emerald-200 bg-emerald-50 px-2 py-1.5 text-center font-semibold text-emerald-700">
                M</th>
              <th
                class="w-[6%] border border-emerald-200 bg-emerald-50 px-2 py-1.5 text-center font-semibold text-emerald-700">
                F</th>
              <th
                class="w-[6%] border border-emerald-200 bg-emerald-50 px-2 py-1.5 text-center font-semibold text-emerald-700">
                N/R</th>
              <th
                class="w-[6%] border border-emerald-200 bg-emerald-100 px-2 py-1.5 text-center font-bold text-emerald-900">
                Total</th>
              <th class="w-[6%] border border-red-200 bg-red-50 px-2 py-1.5 text-center font-semibold text-red-700">M
              </th>
              <th class="w-[6%] border border-red-200 bg-red-50 px-2 py-1.5 text-center font-semibold text-red-700">F
              </th>
              <th class="w-[6%] border border-red-200 bg-red-50 px-2 py-1.5 text-center font-semibold text-red-700">N/R
              </th>
              <th class="w-[6%] border border-red-200 bg-red-100 px-2 py-1.5 text-center font-bold text-red-900">Total
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let c of certificats" class="group border-b border-slate-100 hover:bg-slate-50 cursor-pointer"
              (click)="ouvrirDetailCertificat(c)">
              <td
                class="sticky left-0 z-10 bg-white px-3 py-2.5 text-left font-medium text-slate-800 group-hover:bg-slate-50 border-r border-slate-200">
                {{ c.nom }}
              </td>
              <td class="w-[6%] px-2 py-2.5 text-center border-r border-slate-100">{{ c.effectif.hommes | number }}</td>
              <td class="w-[6%] px-2 py-2.5 text-center border-r border-slate-100">{{ c.effectif.femmes | number }}</td>
              <td class="w-[6%] px-2 py-2.5 text-center border-r border-slate-100">{{ c.effectif.nonRenseigne | number
                }}</td>
              <td
                class="w-[6%] px-2 py-2.5 text-center font-semibold bg-blue-50/40 border-r border-slate-200 text-blue-900">
                {{ c.effectif.total | number }}</td>
              <td class="w-[6%] px-2 py-2.5 text-center border-r border-slate-100">{{ c.connectes.hommes | number }}
              </td>
              <td class="w-[6%] px-2 py-2.5 text-center border-r border-slate-100">{{ c.connectes.femmes | number }}
              </td>
              <td class="w-[6%] px-2 py-2.5 text-center border-r border-slate-100">{{ c.connectes.nonRenseigne | number
                }}</td>
              <td
                class="w-[6%] px-2 py-2.5 text-center font-semibold bg-emerald-50/40 border-r border-slate-200 text-emerald-900">
                {{ c.connectes.total | number }}</td>
              <td class="w-[6%] px-2 py-2.5 text-center border-r border-slate-100">{{ c.jamaisConnectes.hommes | number
                }}</td>
              <td class="w-[6%] px-2 py-2.5 text-center border-r border-slate-100">{{ c.jamaisConnectes.femmes | number
                }}</td>
              <td class="w-[6%] px-2 py-2.5 text-center border-r border-slate-100">{{ c.jamaisConnectes.nonRenseigne |
                number }}</td>
              <td class="w-[6%] px-2 py-2.5 text-center font-semibold bg-red-50/40 text-red-900">{{
                c.jamaisConnectes.total | number }}</td>
            </tr>
          </tbody>
          <tfoot *ngIf="totaux">
            <tr class="bg-slate-100 font-bold text-slate-800">
              <td class="sticky left-0 z-10 bg-slate-100 px-3 py-2.5 text-left border-t-2 border-slate-300">Total</td>
              <td class="w-[6%] px-2 py-2.5 text-center border-t-2 border-slate-300">{{ totaux.effectif.hommes | number
                }}</td>
              <td class="w-[6%] px-2 py-2.5 text-center border-t-2 border-slate-300">{{ totaux.effectif.femmes | number
                }}</td>
              <td class="w-[6%] px-2 py-2.5 text-center border-t-2 border-slate-300">{{ totaux.effectif.nonRenseigne |
                number }}</td>
              <td class="w-[6%] px-2 py-2.5 text-center border-t-2 border-slate-300 bg-blue-100 text-blue-900">{{
                totaux.effectif.total | number }}</td>

              <td class="w-[6%] px-2 py-2.5 text-center border-t-2 border-slate-300">{{ totaux.connectes.hommes | number
                }}</td>
              <td class="w-[6%] px-2 py-2.5 text-center border-t-2 border-slate-300">{{ totaux.connectes.femmes | number
                }}</td>
              <td class="w-[6%] px-2 py-2.5 text-center border-t-2 border-slate-300">{{ totaux.connectes.nonRenseigne |
                number }}</td>
              <td class="w-[6%] px-2 py-2.5 text-center border-t-2 border-slate-300 bg-emerald-100 text-emerald-900">{{
                totaux.connectes.total | number }}</td>

              <td class="w-[6%] px-2 py-2.5 text-center border-t-2 border-slate-300">{{ totaux.jamaisConnectes.hommes |
                number }}</td>
              <td class="w-[6%] px-2 py-2.5 text-center border-t-2 border-slate-300">{{ totaux.jamaisConnectes.femmes |
                number }}</td>
              <td class="w-[6%] px-2 py-2.5 text-center border-t-2 border-slate-300">{{
                totaux.jamaisConnectes.nonRenseigne | number }}</td>
              <td class="w-[6%] px-2 py-2.5 text-center border-t-2 border-slate-300 bg-red-100 text-red-900">{{
                totaux.jamaisConnectes.total | number }}</td>
            </tr>
          </tfoot>
        </table>
      </div>
    </section>
    <section class="mb-6 rounded-xl border border-slate-200 bg-white p-5 pb-4">
      <div class="mb-4 flex items-center justify-between">
        <h2 class="text-[15px] font-bold text-blue-600">Détail des connexions par certificat en pourcentages </h2>
        <button type="button"
          class="flex items-center gap-1.5 rounded-md border border-blue-600 px-3.5 py-1.5 text-[13px] font-semibold text-blue-600 hover:bg-blue-50"
          (click)="exporterXls('pourcentages')">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path d="M12 3v12m0 0l-4-4m4 4l4-4" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"
              stroke-linejoin="round" />
            <path d="M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2" stroke="currentColor" stroke-width="1.8"
              stroke-linecap="round" />
          </svg>
          Exporter cette vue en XLS
        </button>
      </div>

      <div class="overflow-x-auto pb-3">
        <table class="w-full min-w-[1080px] border-collapse text-[13px]">
          <thead>
            <tr>
              <th rowspan="2"
                class="sticky left-0 z-10 w-[28%] border border-slate-200 bg-slate-100 px-3 py-2.5 text-left align-middle font-bold text-slate-800">
                Certificat
              </th>
              <th colspan="3"
                class="w-[24%] border border-blue-200 bg-blue-100 px-3 py-2 text-center text-[13px] font-bold text-blue-900">
                Enrôlés Moodle (%)
              </th>
              <th colspan="3"
                class="w-[24%] border border-emerald-200 bg-emerald-100 px-3 py-2 text-center text-[13px] font-bold text-emerald-900">
                Connectés (%)
              </th>
              <th colspan="3"
                class="w-[24%] border border-red-200 bg-red-100 px-3 py-2 text-center text-[13px] font-bold text-red-900">
                Jamais connectés (%)
              </th>
            </tr>
            <tr>
              <th class="w-[8%] border border-blue-200 bg-blue-50 px-2 py-1.5 text-center font-semibold text-blue-700">M
              </th>
              <th class="w-[8%] border border-blue-200 bg-blue-50 px-2 py-1.5 text-center font-semibold text-blue-700">F
              </th>
              <th class="w-[8%] border border-blue-200 bg-blue-50 px-2 py-1.5 text-center font-semibold text-blue-700">
                N/R</th>
              <th
                class="w-[8%] border border-emerald-200 bg-emerald-50 px-2 py-1.5 text-center font-semibold text-emerald-700">
                M</th>
              <th
                class="w-[8%] border border-emerald-200 bg-emerald-50 px-2 py-1.5 text-center font-semibold text-emerald-700">
                F</th>
              <th
                class="w-[8%] border border-emerald-200 bg-emerald-50 px-2 py-1.5 text-center font-semibold text-emerald-700">
                N/R</th>
              <th class="w-[8%] border border-red-200 bg-red-50 px-2 py-1.5 text-center font-semibold text-red-700">M
              </th>
              <th class="w-[8%] border border-red-200 bg-red-50 px-2 py-1.5 text-center font-semibold text-red-700">F
              </th>
              <th class="w-[8%] border border-red-200 bg-red-50 px-2 py-1.5 text-center font-semibold text-red-700">N/R
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let p of pourcentages" class="group border-b border-slate-100 hover:bg-slate-50">
              <td
                class="sticky left-0 z-10 bg-white px-3 py-2.5 text-left font-medium text-slate-800 group-hover:bg-slate-50 border-r border-slate-200">
                {{ p.nom }}
              </td>
              <td class="w-[8%] px-2 py-2.5 text-center border-r border-slate-100">{{ p.effectif.hommes | number:'1.2-2'
                }}%</td>
              <td class="w-[8%] px-2 py-2.5 text-center border-r border-slate-100">{{ p.effectif.femmes | number:'1.2-2'
                }}%</td>
              <td class="w-[8%] px-2 py-2.5 text-center border-r border-slate-200">{{ p.effectif.nonRenseigne |
                number:'1.2-2' }}%</td>
              <td class="w-[8%] px-2 py-2.5 text-center border-r border-slate-100">{{ p.connectes.hommes |
                number:'1.2-2' }}%</td>
              <td class="w-[8%] px-2 py-2.5 text-center border-r border-slate-100">{{ p.connectes.femmes |
                number:'1.2-2' }}%</td>
              <td class="w-[8%] px-2 py-2.5 text-center border-r border-slate-200">{{ p.connectes.nonRenseigne |
                number:'1.2-2' }}%</td>
              <td class="w-[8%] px-2 py-2.5 text-center border-r border-slate-100">{{ p.jamaisConnectes.hommes |
                number:'1.2-2' }}%</td>
              <td class="w-[8%] px-2 py-2.5 text-center border-r border-slate-100">{{ p.jamaisConnectes.femmes |
                number:'1.2-2' }}%</td>
              <td class="w-[8%] px-2 py-2.5 text-center">{{ p.jamaisConnectes.nonRenseigne | number:'1.2-2' }}%</td>
            </tr>
          </tbody>
          <tfoot *ngIf="totalPourcentages">
            <tr class="bg-slate-100 font-bold text-slate-800">
              <td class="sticky left-0 z-10 bg-slate-100 px-3 py-2.5 text-left border-t-2 border-slate-300">Total</td>
              <td class="w-[8%] px-2 py-2.5 text-center border-t-2 border-slate-300">{{
                totalPourcentages.effectif.hommes | number:'1.2-2' }}%</td>
              <td class="w-[8%] px-2 py-2.5 text-center border-t-2 border-slate-300">{{
                totalPourcentages.effectif.femmes | number:'1.2-2' }}%</td>
              <td class="w-[8%] px-2 py-2.5 text-center border-t-2 border-slate-300 border-r border-slate-300">{{
                totalPourcentages.effectif.nonRenseigne | number:'1.2-2' }}%</td>

              <td class="w-[8%] px-2 py-2.5 text-center border-t-2 border-slate-300">{{
                totalPourcentages.connectes.hommes | number:'1.2-2' }}%</td>
              <td class="w-[8%] px-2 py-2.5 text-center border-t-2 border-slate-300">{{
                totalPourcentages.connectes.femmes | number:'1.2-2' }}%</td>
              <td class="w-[8%] px-2 py-2.5 text-center border-t-2 border-slate-300 border-r border-slate-300">{{
                totalPourcentages.connectes.nonRenseigne | number:'1.2-2' }}%</td>

              <td class="w-[8%] px-2 py-2.5 text-center border-t-2 border-slate-300">{{
                totalPourcentages.jamaisConnectes.hommes | number:'1.2-2' }}%</td>
              <td class="w-[8%] px-2 py-2.5 text-center border-t-2 border-slate-300">{{
                totalPourcentages.jamaisConnectes.femmes | number:'1.2-2' }}%</td>
              <td class="w-[8%] px-2 py-2.5 text-center border-t-2 border-slate-300">{{
                totalPourcentages.jamaisConnectes.nonRenseigne | number:'1.2-2' }}%</td>
            </tr>
          </tfoot>
        </table>
      </div>
    </section>

  </ng-container>
</div>